__turbopack_context__.v({
  "isHome": "mbsTpa_isHome",
  "promobanner-custom": "mbsTpa_promobanner-custom",
  "root": "mbsTpa_root",
  "skip-to-content": "mbsTpa_skip-to-content",
});
